import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

/**
 * Custom hook for data fetching with React Query
 * @param {string} key - Query key
 * @param {Function} fetchFn - Fetch function
 * @param {Object} options - Additional options
 */
export function useFetch({ queryKey, queryFn, enabled = true, options = {} }) {
  return useQuery({
    queryKey,
    queryFn,
    enabled,
    ...options,
    onError: (error) => {
      toast.error(error.message || "An error occurred");
      options.onError?.(error);
    },
  });
}
